import React, { useCallback, useEffect, useState } from 'react';
import { Button, Select, message } from 'antd';
import { attachmentExtensionsApi } from '../../services/api/attachmentExtensionsApi';

interface Photo { id: number; file_url?: string; file_path?: string; file_name?: string; }
export interface UnassignedPhotoTrayProps {
  inspectionId: number;
  points: Array<{ id: number; point_name: string }>;
  onAssigned: () => void;
}
const url = (p: Photo) => `/${(p.file_url ?? p.file_path ?? '').replace(/^.*uploads/, 'uploads')}`;

const UnassignedPhotoTray: React.FC<UnassignedPhotoTrayProps> = ({ inspectionId, points, onAssigned }) => {
  const [photos, setPhotos] = useState<Photo[]>([]);
  const [busy, setBusy] = useState(false);
  const inputRef = React.useRef<HTMLInputElement>(null);

  const load = useCallback(async () => {
    const rows = await attachmentExtensionsApi.listByEntity('dvi_inspection', inspectionId, 'dvi');
    setPhotos(rows);
  }, [inspectionId]);
  useEffect(() => { load(); }, [load]);

  const onFiles = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files ?? []);
    if (!files.length) return;
    setBusy(true);
    try {
      for (const file of files) {
        await attachmentExtensionsApi.uploadPhoto({
          file, entity_type: 'dvi_inspection', entity_id: inspectionId,
          sub_type: 'dvi', visibility: 'customer' });
      }
      await load();
    } catch (err: any) { message.error(`Upload failed: ${err?.message ?? 'unknown'}`); }
    finally { setBusy(false); if (inputRef.current) inputRef.current.value = ''; }
  };

  const assign = async (photoId: number, pointId: number) => {
    await attachmentExtensionsApi.reassign(photoId, 'dvi_inspection_item', pointId);
    setPhotos(p => p.filter(x => x.id !== photoId));
    onAssigned();
  };

  return (
    <div style={{ padding: 8 }}>
      <input ref={inputRef} data-testid="batch-input" type="file" accept="image/*"
        multiple style={{ display: 'none' }} onChange={onFiles} />
      <Button onClick={() => inputRef.current?.click()} loading={busy}>Upload photos</Button>
      {photos.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 8 }}>
          {photos.map(p => (
            <div key={p.id} style={{ width: 120 }}>
              <img src={url(p)} alt={p.file_name ?? `photo ${p.id}`}
                style={{ width: 120, height: 90, objectFit: 'cover', borderRadius: 4 }} />
              <Select size="small" style={{ width: '100%', marginTop: 4 }}
                placeholder="Assign to…" data-testid={`assign-${p.id}`}
                options={points.map(pt => ({ value: pt.id, label: pt.point_name }))}
                onChange={(v) => assign(p.id, Number(v))} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
export default UnassignedPhotoTray;
